import React from 'react';

import {Card, CardHeader, CardContent} from '@mui/material';
import {defineMessages, useIntl} from 'react-intl';

import {Types} from '@wheeebo/polaris-api';

import MemberUpdateForm from '@components/form/MemberUpdateForm';

const msgs = defineMessages({
  headerTitle: {
    id: 'pages.member.group.MemberUpdateCard.header.title',
    defaultMessage: 'Member Data',
  },
  headerSubTitle: {
    id: 'pages.member.group.MemberUpdateCard.header.subTitle',
    defaultMessage: 'Basic information of this member',
  },
});

interface Props {
  memberId: Types.UUID;
}

function MemberUpdateCard({memberId}: Props): JSX.Element {
  const intl = useIntl();
  return (
    <Card>
      <CardHeader title={intl.formatMessage(msgs.headerTitle)} subheader={intl.formatMessage(msgs.headerSubTitle)} />
      <CardContent>
        <MemberUpdateForm memberId={memberId} />
      </CardContent>
    </Card>
  );
}
export default React.memo(MemberUpdateCard);
